import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import PropTypes from 'prop-types';
import { cellRendererWithToolTip } from './detailsItem';

var Subscribers = function Subscribers(_ref) {
  var subscriberDetails = _ref.subscriberDetails;

  if (!subscriberDetails) {
    return null;
  }

  var subscriptionType = subscriberDetails.subscriptionType,
      subscribers = subscriberDetails.subscribers;
  var cellData = '';

  if (subscriptionType === 1) {
    var subscriberEmails = _mapInstanceProperty(subscribers).call(subscribers, function (subscriber) {
      return subscriber.subscriberEmail;
    });

    cellData = subscriberEmails.join(', ');
  } else {
    cellData = 'All Druva Cloud Administrator';
  }

  return cellRendererWithToolTip({
    cellData: cellData
  });
};

Subscribers.propTypes = {
  subscriberDetails: PropTypes.object
};
export default Subscribers;